export const STAGES = [
  "Pipeline", "Upside", "Commit", "Order Loaded", "Material Delivered",
  "Invoiced", "Support Team Assigned", "Ongoing Project", "Project Completed",
  "RR", "Order Lost",
];

export const QUARTERS = ["Q1", "Q2", "Q3", "Q4"];

export const ROLES = [
  { value: "super_admin", label: "Super Admin" },
  { value: "hr", label: "Finance Manager" },
  { value: "sales_manager", label: "Sales Manager" },
  { value: "department_manager", label: "Department Manager" },
  { value: "employee", label: "Employee" },
  { value: "finance_team", label: "Finance Team" },
];

export const ORDER_CREATOR_ROLES = ["super_admin", "sales_manager", "finance_team"];

/**
 * Get the human-readable label for a role code.
 * `hr` is displayed as "Finance Manager" per Feb-2026 rename.
 * Falls back to Title-Case of the code for any unknown role
 * (e.g., legacy `finance_manager` also becomes "Finance Manager").
 */
export const roleLabel = (code) => {
  if (!code) return "";
  const found = ROLES.find((r) => r.value === code);
  if (found) return found.label;
  if (code === "finance_manager") return "Finance Manager";
  return code.replace(/_/g, " ").replace(/\b\w/g, (c) => c.toUpperCase());
};

export const EXPENSE_TYPES = [
  { value: "flight", label: "Flight" },
  { value: "train", label: "Train" },
  { value: "bus", label: "Bus" },
  { value: "auto", label: "Auto" },
  { value: "metro", label: "Metro" },
  { value: "e_rickshaw", label: "E-Rickshaw" },
  { value: "bike", label: "Bike" },
  { value: "hotel", label: "Hotel" },
  { value: "taxi", label: "Taxi" },
  { value: "fuel", label: "Fuel" },
  { value: "food", label: "Food" },
  { value: "phone_bill", label: "Phone Bill" }, // kept for backend enum & legacy view; UI hides from most flows
  { value: "other", label: "Other" },
];

export const PRIORITIES = [
  { value: "low", label: "Low" },
  { value: "medium", label: "Medium" },
  { value: "high", label: "High" },
  { value: "critical", label: "Critical" },
];

export const stageChipClass = (s) => {
  const m = {
    "Pipeline": "chip-pipeline",
    "Upside": "chip-upside",
    "Commit": "chip-commit",
    "Order Loaded": "chip-order-loaded",
    "Material Delivered": "chip-material-delivered",
    "Invoiced": "chip-invoiced",
    "Support Team Assigned": "chip-support",
    "Ongoing Project": "chip-ongoing",
    "Project Completed": "chip-completed",
    "RR": "chip-rr",
    "Order Lost": "chip-lost",
  };
  return m[s] || "chip-pipeline";
};
